import { createStore } from 'vuex'
import { auth } from "./auth.module"
import { payment_inprogress } from "./payment_inprogress.module"
import { profil } from "./profil.module"
import { token } from "./token.module"
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  key: 'store-lep-ges-immo',
  modules: ['token', 'profil', 'auth'],
})

const store = createStore({
  modules: {
    auth,
    payment_inprogress,
    profil,
    token,
  },
  plugins: [vuexLocal.plugin,],
});

export default store;
